import LessonBehaviorSettings from './models/LessonBehaviorSettings';
import { LessonComponentType } from './models/LessonComponentType';
import LessonDisplaySettings from './models/LessonDisplaySettings';

const selectionComponent = '909a7c02-7d5c-410a-9508-95b144a773bc';
const fill_blank_menu = 'd764bbbf-b3f0-4a34-a069-80b49e8c00c6';

/** Review link with extended expiry upto Year `2050`. */
const componentLinkKeys: { [key: LessonComponentType]: string } = {
  list: '7441494f-12f0-4ac1-989c-692687ef61ea',
  audio: '48abd11a-d4a4-44d1-ab66-62276766d505',
  embed: '1c2c32a7-5913-4321-b988-d33a303f8e4c',
  sorter: '06675f23-6f0c-42fa-8cf6-ade1bbe5a1ac',
  full_width_image: 'c6bc64ec-b0c5-4022-8685-75391a831c9a',
  carousel: '9446e9fd-f3a1-429a-bbaa-754f5dc1f479',
  hotspot: 'b6bb139f-17ce-4fa4-8db1-99d1f32c6947',
  sequencer: 'ce803ffc-ed2c-4441-b232-142f876bd063',
  slider: '8d0b34a5-7ce8-43d7-9c0c-6016d6978d6a',
  // Following 2 fill blank and fill menu components share same lesson
  fill_blank: fill_blank_menu,
  fill_menu: fill_blank_menu,
  screen_capture: '46ea4835-ddc9-4a81-8823-be47104dea9d',
  screen_capture_comparison: '9e7351a6-f8c0-4134-89a4-3c699b828de1',
  // Following 4 selection components share same lesson
  single_selection: selectionComponent,
  multiple_selection: selectionComponent,
  single_selection_card: selectionComponent,
  multiple_selection_card: selectionComponent,
  flip_card: '5db974c8-316b-4bb3-8fb3-25bb4179b800',
  column: 'b0fa6b5b-206f-4cf7-930d-454d58a913c4',
  table: '90b8be5d-1e40-4099-b7e0-1f437c7fded7',
  icon_text: 'b66a3153-be86-48d3-a898-a06f8f1d9659',
  gallery: 'a374762b-a956-4fad-9f62-1bf6039d8993',
  timeline: 'dffdfab6-5ad3-470d-840c-0e2d7d8c3a36'
};
interface IConstants {
  NoOp: Function;
  DefaultLessonBehaviorSettings: LessonBehaviorSettings;
  SorterMaxNumCategories: number;
  InvalidComponentkey: number;
  DefaultDisplaySettings: LessonDisplaySettings;
  ImageText: string;
  VideoText: string;
  AudioText: string;
  CarouselMaxNumItems: number; //Number of maximum carousel items
  /** Template for URL to share a lesson preview. */
  LinkLessonUrl: string;
  ScreenCaptureMaxNumItems: number; //Number of maximum carousel items
  SelectionCardMaxNumItems: number;
  FlipCardMaxNumItems: number;
  FillMenuPlaceholder: string;
  GalleryMaxNumImages: number;
  ColumnComponentDefaultItems: number;
  GalleryComponentDefaultItems: number;
  HelpLinkBaseUrl: string;
  HelpLinkKeys: { [key: string]: string };
  WarningFreeTextCharacters: number;
  MaximumFreeTextCharacters: number;
  MaxFormattingFreeTextCharacters: number;
}

const Constants: IConstants = {
  NoOp: () => {},
  DefaultLessonBehaviorSettings: <LessonBehaviorSettings>{
    showAllVersions: false,
    lockCompletedLessons: false,
    lockCourse: false,
    multipleAttempts: true,
    editAllVersions: false,
    completionType: 'threshold',
    completionThreshold: 100 //* %
  },
  SorterMaxNumCategories: 4,
  InvalidComponentkey: 0, //* Negative values are used for newly created but not saved components.
  DefaultDisplaySettings: {
    background: {
      type: 'color',
      value: '',
      containerColor: '#ffffffe6'
    },
    icon: {
      type: 'color',
      value: ''
    }
  },
  ImageText: 'The image can be changed from the component settings area',
  VideoText: 'The video can be changed from the component settings area',
  AudioText: 'The audio can be changed from the component settings area',
  CarouselMaxNumItems: 8,
  LinkLessonUrl: '/e/link/lesson/:linkkey',
  ScreenCaptureMaxNumItems: 8,
  SelectionCardMaxNumItems: 6,
  FlipCardMaxNumItems: 8,
  FillMenuPlaceholder: 'Select',
  GalleryMaxNumImages: 4,
  ColumnComponentDefaultItems: 2,
  GalleryComponentDefaultItems: 3,
  HelpLinkBaseUrl: 'https://tipsandtricks.bracken.cloud',
  HelpLinkKeys: componentLinkKeys,
  WarningFreeTextCharacters: 2800,
  MaximumFreeTextCharacters: 3000,
  MaxFormattingFreeTextCharacters: 3900
};

export default Constants;
